import { AdsController, NullAdsController } from "@mp-commons/modules/ads/AdsController.js";
import { GDPRPromise, GDPRSdk } from "@mp-commons/modules/ads/GDPR.js";
import { AbstractImaController } from "@mp-commons/modules/ads/ima/AbstractImaController.js";
import { loadImaSdk } from "@mp-commons/modules/ads/ima/ImaLoader.js";

/**
 * Builds an instance of an AdsController using the provided builder function,
 * after asynchronously loading the IMA SDK and resolving GDPR consent.
 *
 * @template A - A type extending AbstractImaController.
 * @param builder - A function that receives the loaded IMA SDK and GDPRSdk, and returns an instance of A.
 * @param debug - Optional flag to enable debug mode when loading the IMA SDK. Defaults to true.
 * @returns A promise that resolves to an AdsController. If loading the IMA SDK fails, resolves to a NullAdsController.
 */
export function ImaControllerBuilder<A extends AbstractImaController>(builder: (ima: typeof google.ima, gdpr: GDPRSdk) => A, debug: boolean = true): Promise<AdsController> {

    return loadImaSdk(window,debug).then(ima => {
        return GDPRPromise().then(gdpr => {
            return builder(ima,gdpr);
        });
    }).catch(err => {
        console.error("ERROR LOADING IMA ",err);
        return Promise.resolve(new NullAdsController());
    });

}